/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReferralSource
 */
export interface ReferralSource {
    /**
     * 
     * @type {string}
     * @memberof ReferralSource
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralSource
     */
    referral_date: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralSource
     */
    referral_taken_by: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralSource
     */
    physician_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralSource
     */
    physician_contact?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralSource
     */
    facility_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralSource
     */
    relationship_to_patient?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralSource
     */
    contact_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralSource
     */
    contact_type?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralSource
     */
    contact_work_phone?: string;
}

/**
 * Check if a given object implements the ReferralSource interface.
 */
export function instanceOfReferralSource(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "referral_date" in value;
    isInstance = isInstance && "referral_taken_by" in value;

    return isInstance;
}

export function ReferralSourceFromJSON(json: any): ReferralSource {
    return ReferralSourceFromJSONTyped(json, false);
}

export function ReferralSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferralSource {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'referral_date': json['referral_date'],
        'referral_taken_by': json['referral_taken_by'],
        'physician_name': !exists(json, 'physician_name') ? undefined : json['physician_name'],
        'physician_contact': !exists(json, 'physician_contact') ? undefined : json['physician_contact'],
        'facility_name': !exists(json, 'facility_name') ? undefined : json['facility_name'],
        'relationship_to_patient': !exists(json, 'relationship_to_patient') ? undefined : json['relationship_to_patient'],
        'contact_name': !exists(json, 'contact_name') ? undefined : json['contact_name'],
        'contact_type': !exists(json, 'contact_type') ? undefined : json['contact_type'],
        'contact_work_phone': !exists(json, 'contact_work_phone') ? undefined : json['contact_work_phone'],
    };
}

export function ReferralSourceToJSON(value?: ReferralSource | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'referral_date': value.referral_date,
        'referral_taken_by': value.referral_taken_by,
        'physician_name': value.physician_name,
        'physician_contact': value.physician_contact,
        'facility_name': value.facility_name,
        'relationship_to_patient': value.relationship_to_patient,
        'contact_name': value.contact_name,
        'contact_type': value.contact_type,
        'contact_work_phone': value.contact_work_phone,
    };
}

